
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6fYhs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8kTwy = parcelRequire("8kTwy");


var $hWVhC = parcelRequire("hWVhC");

const $0b88e3f93b4ae168$export$795b3bdb48c9bf24 = ({ storageAdapter: storageAdapter, experienceUrl: experienceUrl, analyticsAttributes: analyticsAttributes })=>{
    // If there is an issue fetching the experience url, do not render the modal
    if (!experienceUrl) return null;
    // Determine which modal to show
    const modalToShow = (0, $8kTwy.getModalToShow)(storageAdapter, (0, $8kTwy.Product).Confluence);
    // Render the appropriate modal component
    switch(modalToShow){
        case (0, $8kTwy.UpgradeModalComponent).ConfluenceStandardOfferAIModalFirstTime:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $hWVhC.ConfluenceStandardOfferAIModal), {
                analyticsAttributes: analyticsAttributes,
                experienceUrl: experienceUrl,
                storageAdapter: storageAdapter,
                nthTimeShown: 1
            });
        case (0, $8kTwy.UpgradeModalComponent).ConfluenceStandardOfferAIModalSecondTime:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $hWVhC.ConfluenceStandardOfferAIModal), {
                analyticsAttributes: analyticsAttributes,
                experienceUrl: experienceUrl,
                storageAdapter: storageAdapter,
                nthTimeShown: 2
            });
        case (0, $8kTwy.UpgradeModalComponent).None:
        default:
            return null;
    }
};



var $gwZbZ = parcelRequire("gwZbZ");


var $jMyy4 = parcelRequire("jMyy4");


var $gKr8t = parcelRequire("gKr8t");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $euL71 = parcelRequire("euL71");


var $17wUi = parcelRequire("17wUi");


var $a7QKb = parcelRequire("a7QKb");





var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");



var $6o7wX = parcelRequire("6o7wX");

const $df6c0141e3226043$export$234372c4336ce5a8 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { experimentKey: experimentKey, defaultAdditionalAttributes: defaultAdditionalAttributes = {} } = options;
    const trackError = (0, $42omo.useCallback)((params)=>{
        const { errorType: errorType, errorMessage: errorMessage, severity: severity, source: source, cohort: cohort, additionalAttributes: additionalAttributes = {} } = params;
        const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
            product: (0, $gwZbZ.Product).CONFLUENCE,
            team: (0, $6o7wX.Team).GROWTH_LUNA,
            experimentMeta: {
                experimentKey: experimentKey,
                cohort: cohort
            },
            errorType: errorType,
            errorMessage: errorMessage,
            severity: severity,
            source: source,
            additionalAttributes: {
                ...defaultAdditionalAttributes,
                ...additionalAttributes
            }
        });
        createAnalyticsEvent(eventPayload).fire();
    }, [
        createAnalyticsEvent,
        experimentKey,
        defaultAdditionalAttributes
    ]);
    const fireExperimentExposureEvent = (0, $42omo.useCallback)((config)=>{
        try {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'experiment',
                    actionSubjectId: config.actionSubjectId,
                    attributes: {
                        cohort: config.cohort,
                        ...defaultAdditionalAttributes
                    },
                    source: config.source
                }
            }).fire();
            return true; // success
        } catch (error) {
            trackError({
                errorType: (0, $gwZbZ.ErrorType).GENERIC,
                errorMessage: error instanceof Error ? error.message : 'Analytics event failed',
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: `${config.source}_analytics`,
                cohort: config.cohort,
                additionalAttributes: {
                    experimentId: config.experimentId,
                    cohort: config.cohort,
                    errorStack: error instanceof Error ? error.stack : undefined,
                    errorName: error instanceof Error ? error.name : undefined
                }
            });
            return false; // failure
        }
    }, [
        createAnalyticsEvent,
        trackError,
        defaultAdditionalAttributes
    ]);
    return {
        trackError: trackError,
        fireExperimentExposureEvent: fireExperimentExposureEvent
    };
};



var $a6Um0 = parcelRequire("a6Um0");

/**
 * @generated SignedSource<<305d89e4975a254168696c582e5a3d7f>>
 * @relayHash b8f7201dedaae8bbc3ae18ef0fd52a7e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b315aa47f2f58b3f27b20a9456560c64af1a8dd08c654537378d1fc205bc4b65
const $b024be704ed1b901$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "args": [
            {
                "kind": "Literal",
                "name": "chargeElement",
                "value": "user"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement",
        "storageKey": "latestUsageForChargeElement(chargeElement:\"user\")"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v6 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "createdAt"
            }
        ],
        "type": "CcpEntitlement"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "standard"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v10 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        v12 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"standard\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v13 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"standard\")"
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8f7201dedaae8bbc3ae18ef0fd52a7e",
            "id": "b315aa47f2f58b3f27b20a9456560c64af1a8dd08c654537378d1fc205bc4b65",
            "metadata": {},
            "name": "ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery",
            "operationKind": "query",
            "text": "query ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,latestUsageForChargeElement(chargeElement:\"user\"),preDunning{__typename,status},transactionAccount{__typename,isBillToPresent,...on Node{__isNode:__typename,id}},subscription{__typename,trial{__typename,timeLeft},...on CcpSubscription{id}},...on CcpEntitlement{createdAt},experienceCapabilities{__typename,changeOfferingV2(offeringName:\"standard\"){__typename,isAvailableToUser,experienceUrl}},id}}}}"
        }
    };
}();
$b024be704ed1b901$var$node.hash = "4095749cfc0289fbe8c9a1dab75c85a2";
var $b024be704ed1b901$export$2e2bcd8739ae039 = $b024be704ed1b901$var$node;


const $be3eeff721478f0e$export$f2ce774352f27633 = (0, $b024be704ed1b901$export$2e2bcd8739ae039);





const $efcaf25c7211cfbb$export$15af0670bab5d01d = (data)=>{
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const hasNoTrialHistory = Array.isArray(entitlement?.entitlementProfile?.trialHistory) && entitlement?.entitlementProfile?.trialHistory.length === 0;
    const hasOnlyReverseTrialedWithoutPaidFeatureUsage = Array.isArray(entitlement?.entitlementProfile?.trialHistory) && entitlement?.entitlementProfile?.trialHistory.length === 1 && entitlement?.entitlementProfile?.trialHistory[0].trialType === 'REVERSE_TRIAL' && Array.isArray(entitlement?.entitlementProfile?.paidFeatureUsage) && entitlement?.entitlementProfile?.paidFeatureUsage?.length === 0;
    const memoizedAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            hasNoTrialHistory: hasNoTrialHistory,
            hasOnlyReverseTrialedWithoutPaidFeatureUsage: hasOnlyReverseTrialedWithoutPaidFeatureUsage
        };
    }, [
        hasNoTrialHistory,
        hasOnlyReverseTrialedWithoutPaidFeatureUsage
    ]);
    return {
        isEligibleViaGUPS: Boolean(hasNoTrialHistory || hasOnlyReverseTrialedWithoutPaidFeatureUsage),
        analyticsAttributes: memoizedAnalyticsAttributes
    };
};






var $917iu = parcelRequire("917iu");





var $1o4fX = parcelRequire("1o4fX");





var $6Co6F = parcelRequire("6Co6F");

const $4b905585be950ab8$export$27aa48a6b5521530 = (url)=>{
    if (!url) return '';
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};



const $c7b614996e28227a$export$6b91b4bea3708de6 = (data, edition)=>{
    const { trackError: trackError } = (0, $df6c0141e3226043$export$234372c4336ce5a8)({
        experimentKey: 'twcg-206_confluence_upgrade_permanent_free'
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    let hasPaymentDetailsEntered;
    let trialTimeLeft;
    let isInPredunning;
    let licensedUsersRaw;
    let createdAt;
    let accountAgeDays;
    let isEligible = false;
    let isAvailableToUser;
    let experienceUrl = '';
    try {
        licensedUsersRaw = entitlement?.latestUsageForChargeElement ?? 1;
        hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING';
        trialTimeLeft = entitlement?.subscription?.trial?.timeLeft ?? undefined;
        const trialDaysLeft = (0, $1o4fX.getTrialDaysLeft)(trialTimeLeft);
        const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
        createdAt = entitlement?.createdAt ?? Date.now();
        accountAgeDays = (0, $917iu.default)(new Date(), new Date(createdAt));
        isAvailableToUser = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser ?? false;
        isEligible = Boolean(edition === (0, $euL71.ConfluenceEdition).FREE && licensedUsersRaw >= 2 && !isInPredunning && !isInTrial && hasPaymentDetailsEntered && accountAgeDays > 120 && isAvailableToUser);
        experienceUrl = isAvailableToUser ? (0, $4b905585be950ab8$export$27aa48a6b5521530)(entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? '') : '';
    } catch (error) {
        trackError({
            errorType: (0, $gwZbZ.ErrorType).GENERIC,
            errorMessage: error instanceof Error ? error.message : 'Experiment eligibility determination failed',
            severity: (0, $gwZbZ.Severity).MEDIUM,
            source: 'useIsEligibleForExperiment_eligibilityCalculation',
            cohort: undefined,
            additionalAttributes: {
                hasEntitlementData: Boolean(entitlement),
                dataKeys: entitlement ? Object.keys(entitlement) : [],
                errorStack: error instanceof Error ? error.stack : undefined,
                errorName: error instanceof Error ? error.name : undefined
            }
        });
    }
    const memoizedAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            accountAgeDays: accountAgeDays,
            licensedUsers: licensedUsersRaw,
            experienceUrl: experienceUrl
        };
    }, [
        accountAgeDays,
        licensedUsersRaw,
        experienceUrl
    ]);
    return {
        isEligible: isEligible,
        experienceUrl: experienceUrl,
        analyticsAttributes: memoizedAnalyticsAttributes
    };
};









var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


const $28928e5c9446f096$var$UPFT_COHORT_LOCAL_STORAGE_KEY = 'atl-UPFTConfluenceStandardOfferCohort';
const $28928e5c9446f096$export$8d3119325ec91e35 = ({ isEligible: isEligible, analyticsAttributes: analyticsAttributes, confluenceStorageAdapter: confluenceStorageAdapter })=>{
    const { trackError: trackError, fireExperimentExposureEvent: fireExperimentExposureEvent } = (0, $df6c0141e3226043$export$234372c4336ce5a8)({
        defaultAdditionalAttributes: analyticsAttributes,
        experimentKey: 'twcg-206_confluence_upgrade_permanent_free'
    });
    const [abCohort, setABCohort] = (0, $42omo.useState)('not-enrolled');
    // Track if analytics events have been fired to prevent duplicates
    const abEventFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (isEligible && (0, $9wGTI.fg)('twcg-206_confluence_upgrade_permanent_free_fg')) try {
            setABCohort((0, $6mKj3.expVal)('twcg-206_confluence_upgrade_permanent_free', 'cohort', 'not-enrolled'));
            confluenceStorageAdapter.set($28928e5c9446f096$var$UPFT_COHORT_LOCAL_STORAGE_KEY, (0, $6mKj3.expVal)('twcg-206_confluence_upgrade_permanent_free', 'cohort', 'not-enrolled'));
        } catch (error) {
            trackError({
                errorType: (0, $gwZbZ.ErrorType).GENERIC,
                errorMessage: error instanceof Error ? error.message : 'Experiment cohort determination failed',
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'useUpgradeFreePoolTargetExperimentCohort_cohortDetermination',
                cohort: 'not-enrolled',
                additionalAttributes: {
                    isEligible: isEligible,
                    featureGateEnabled: (0, $9wGTI.fg)('twcg-206_confluence_upgrade_permanent_free_fg'),
                    errorStack: error instanceof Error ? error.stack : undefined,
                    errorName: error instanceof Error ? error.name : undefined
                }
            });
            // Fall back to not-enrolled on error
            setABCohort('not-enrolled');
        }
    }, [
        isEligible,
        trackError,
        confluenceStorageAdapter
    ]);
    (0, $42omo.useEffect)(()=>{
        if (abCohort !== 'not-enrolled' && !abEventFiredRef.current) {
            const success = fireExperimentExposureEvent({
                cohort: abCohort,
                experimentId: 'twcg-206_confluence_upgrade_permanent_free',
                actionSubjectId: 'twcg-206_confluence_upgrade_permanent_free_exposed',
                source: 'twcg-206_confluence_upgrade_permanent_free'
            });
            if (success) abEventFiredRef.current = true;
        }
    }, [
        abCohort,
        fireExperimentExposureEvent
    ]);
    return {
        abCohort: abCohort
    };
};


const $b4254f16cd85c797$export$65a95ea13cf22368 = ()=>{
    const { cloudId: cloudId, edition: edition, isLoggedIn: isLoggedIn, activationId: activationId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { trackError: trackError } = (0, $df6c0141e3226043$export$234372c4336ce5a8)({
        defaultAdditionalAttributes: {
            edition: edition
        },
        experimentKey: 'twcg-206_confluence_upgrade_permanent_free'
    });
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const canSkipQuery = !cloudId || !edition || edition !== (0, $euL71.ConfluenceEdition).FREE || !isLoggedIn || !activationId || !userId || !isLicensed;
    // The GUPS query is SSR'd since it will whittle down the experiment audience significantly
    const { data: gupsEligibilityData } = (0, $jMyy4.useQueryInterop)((0, $a6Um0.ConfluenceFreePoolTargetExperimentGUPSQuery), {
        variables: {
            cloudId: cloudId,
            productKey: 'confluence.ondemand'
        },
        skip: canSkipQuery,
        fetchPolicy: 'cache-first',
        client: (0, $gKr8t.getAGGClient)(),
        onError: (graphqlError)=>{
            trackError({
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: graphqlError.message,
                severity: (0, $gwZbZ.Severity).HIGH,
                source: 'ConfluenceFreePoolTargetExperimentGUPSQuery',
                cohort: undefined,
                additionalAttributes: {
                    variables: {
                        cloudId: cloudId,
                        productKey: 'confluence.ondemand'
                    },
                    canSkipQuery: canSkipQuery,
                    errorStack: graphqlError.stack,
                    errorName: graphqlError.name
                }
            });
        }
    });
    const { isEligibleViaGUPS: isEligibleViaGUPS, analyticsAttributes: gupsAnalyticsAttributes } = (0, $efcaf25c7211cfbb$export$15af0670bab5d01d)(gupsEligibilityData);
    // Only request for other eligibility criteria if eligible via GUPS
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $be3eeff721478f0e$export$f2ce774352f27633), {
        variables: {
            cloudId: cloudId,
            productKey: 'confluence.ondemand'
        },
        skip: canSkipQuery || !isEligibleViaGUPS,
        fetchPolicy: 'cache-first',
        client: (0, $gKr8t.getAGGClient)(),
        onError: (graphqlError)=>{
            trackError({
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: graphqlError.message,
                severity: (0, $gwZbZ.Severity).HIGH,
                source: 'ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery',
                cohort: undefined,
                additionalAttributes: {
                    variables: {
                        cloudId: cloudId,
                        productKey: 'confluence.ondemand'
                    },
                    canSkipQuery: canSkipQuery || !isEligibleViaGUPS,
                    errorStack: graphqlError.stack,
                    errorName: graphqlError.name
                }
            });
        }
    });
    const { isEligible: isEligibleViaAddtlAttributes, experienceUrl: experienceUrl, analyticsAttributes: addtlAnalyticsAttributes } = (0, $c7b614996e28227a$export$6b91b4bea3708de6)(data, edition);
    const confluenceStorageAdapter = (0, $42omo.useMemo)(()=>({
            get: (key)=>{
                return (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
            },
            set: (key, value)=>{
                (0, $17wUi.confluenceLocalStorageInstance).setItem(key, value);
            },
            removeItem: (key)=>{
                (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
            }
        }), []);
    const analyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            ...gupsAnalyticsAttributes,
            ...addtlAnalyticsAttributes
        };
    }, [
        gupsAnalyticsAttributes,
        addtlAnalyticsAttributes
    ]);
    const { abCohort: abCohort } = (0, $28928e5c9446f096$export$8d3119325ec91e35)({
        isEligible: isEligibleViaGUPS && isEligibleViaAddtlAttributes,
        analyticsAttributes: analyticsAttributes,
        confluenceStorageAdapter: confluenceStorageAdapter
    });
    if (abCohort !== 'variation') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7QKb.ExperimentErrorBoundaryWrapper), {
        experimentKey: "twcg-206_confluence_upgrade_permanent_free",
        source: "UpgradeFreePoolExperimentModalPreUpgradeModalBaseComponent",
        cohort: abCohort,
        additionalAttributes: {
            cloudId: cloudId,
            edition: edition,
            experienceUrl: experienceUrl,
            isEligibleViaGUPS: isEligibleViaGUPS,
            isEligibleViaAddtlAttributes: isEligibleViaAddtlAttributes,
            analyticsAttributes: analyticsAttributes
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0b88e3f93b4ae168$export$795b3bdb48c9bf24), {
        storageAdapter: confluenceStorageAdapter,
        experienceUrl: experienceUrl,
        analyticsAttributes: analyticsAttributes
    }));
};
module.exports["UpgradeFreePoolExperimentModalPreUpgradeModalBaseComponent"] = $b4254f16cd85c797$export$65a95ea13cf22368;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("a6Um0", function(module, exports) {

var $1zWWy = parcelRequire("1zWWy");

const $99f2b2566e7fe177$export$2c5427f7017c6289 = (0, $1zWWy.default);
module.exports["ConfluenceFreePoolTargetExperimentGUPSQuery"] = $99f2b2566e7fe177$export$2c5427f7017c6289;

});

parcelRegister("1zWWy", function(module, exports) {
/**
 * @generated SignedSource<<13e0b0e3a953c91b8611e5fe49730f75>>
 * @relayHash 4f3a22febe58e2efc8cc3c914b81aeb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91130861c7c3ed20ae2d1ed7c3d0757d2bbf52dbc1ed25d26a638241967255cd
const $2377b8263450ac78$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
        "kind": "LinkedField",
        "name": "entitlementProfile",
        "plural": false,
        "selections": [
            {
                "concreteType": "GrowthUnifiedProfilePaidFeatureUsageResult",
                "kind": "LinkedField",
                "name": "paidFeatureUsage",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "featureName"
                    }
                ]
            },
            {
                "concreteType": "GrowthUnifiedProfileTrialHistoryResult",
                "kind": "LinkedField",
                "name": "trialHistory",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "trialType"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConfluenceFreePoolTargetExperimentGUPSQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConfluenceFreePoolTargetExperimentGUPSQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4f3a22febe58e2efc8cc3c914b81aeb4",
            "id": "91130861c7c3ed20ae2d1ed7c3d0757d2bbf52dbc1ed25d26a638241967255cd",
            "metadata": {},
            "name": "ConfluenceFreePoolTargetExperimentGUPSQuery",
            "operationKind": "query",
            "text": "query ConfluenceFreePoolTargetExperimentGUPSQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,entitlementProfile{paidFeatureUsage{featureName},trialHistory{trialType}},id}}}}"
        }
    };
}();
$2377b8263450ac78$var$node.hash = "5f65891d6aee930b0244af3e809710e5";
var $2377b8263450ac78$export$2e2bcd8739ae039 = $2377b8263450ac78$var$node;
module.exports["default"] = $2377b8263450ac78$export$2e2bcd8739ae039;

});

parcelRegister("iJUOw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $59OcG = parcelRequire("59OcG");


var $4gAvD = parcelRequire("4gAvD");


var $lJwTu = parcelRequire("lJwTu");

const $a38eaca20b61fcf5$var$hasSideContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
    borderRadius: 'radius.small',
    [(0, $bWLcG.media).above.sm]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    }
});
const $a38eaca20b61fcf5$var$baseContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $a38eaca20b61fcf5$var$stack = (0, $ecnYn.xcss)({
    height: '100%',
    padding: 'space.600',
    overflowY: 'auto'
});
const $a38eaca20b61fcf5$var$sideContainer = (0, $ecnYn.xcss)({
    display: 'none',
    [(0, $bWLcG.media).above.sm]: {
        backgroundColor: 'color.background.accent.gray.subtlest',
        display: 'flex',
        width: '100%',
        overflowY: 'auto'
    }
});
const $a38eaca20b61fcf5$var$leftSideContainer = (0, $ecnYn.xcss)({
    [(0, $bWLcG.media).above.sm]: {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 3px)",
        borderBottomLeftRadius: "var(--ds-radius-xlarge, 3px)"
    }
});
const $a38eaca20b61fcf5$var$rightSideContainer = (0, $ecnYn.xcss)({
    [(0, $bWLcG.media).above.sm]: {
        borderTopRightRadius: "var(--ds-radius-xlarge, 3px)",
        borderBottomRightRadius: "var(--ds-radius-xlarge, 3px)"
    }
});
const $a38eaca20b61fcf5$var$closeButtonStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.200',
    right: 'space.200',
    zIndex: '1'
});
const $a38eaca20b61fcf5$export$2b77a92f1a5ad772 = ({ logo: logo, title: title, subtitle: subtitle, subtitleColor: subtitleColor = 'color.text.subtle', children: children, actions: actions, right: right, sideContent: sideContent, sideLocation: sideLocation = 'right', renderedInsideEntrypoint: renderedInsideEntrypoint, backgroundColor: backgroundColor, includeCloseButton: includeCloseButton = false, ...modalProps })=>{
    const hasSideContent = !!right || !!sideContent;
    const rightContent = right ?? (sideLocation === 'right' ? sideContent : undefined);
    const leftContent = !right && sideLocation === 'left' ? sideContent : undefined;
    const safeOnClose = typeof modalProps.onClose === 'function' ? modalProps.onClose : ()=>{};
    if (renderedInsideEntrypoint) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $a38eaca20b61fcf5$var$baseContainerStyles,
            hasSideContent ? $a38eaca20b61fcf5$var$hasSideContentContainerStyles : undefined
        ],
        backgroundColor: backgroundColor,
        style: {
            height: modalProps.height
        },
        children: [
            includeCloseButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $a38eaca20b61fcf5$var$closeButtonStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                    testId: "modal-close-button",
                    onClick: safeOnClose
                })
            }),
            !!leftContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $a38eaca20b61fcf5$var$sideContainer,
                    $a38eaca20b61fcf5$var$leftSideContainer
                ],
                children: leftContent
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.400",
                xcss: $a38eaca20b61fcf5$var$stack,
                children: [
                    logo,
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $lJwTu.ModalTitle), {
                                children: title
                            }),
                            subtitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: subtitleColor,
                                size: "medium",
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $59OcG.ModalBody), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4gAvD.ModalFooter), {
                        children: actions
                    })
                ]
            }),
            !!rightContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $a38eaca20b61fcf5$var$sideContainer,
                    $a38eaca20b61fcf5$var$rightSideContainer
                ],
                children: rightContent
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
        width: hasSideContent ? 'x-large' : undefined,
        ...modalProps,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $a38eaca20b61fcf5$var$baseContainerStyles,
                hasSideContent ? $a38eaca20b61fcf5$var$hasSideContentContainerStyles : undefined
            ],
            backgroundColor: backgroundColor,
            children: [
                includeCloseButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $a38eaca20b61fcf5$var$closeButtonStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                        testId: "modal-close-button",
                        onClick: safeOnClose
                    })
                }),
                !!leftContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $a38eaca20b61fcf5$var$sideContainer,
                        $a38eaca20b61fcf5$var$leftSideContainer
                    ],
                    children: leftContent
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                    space: "space.400",
                    xcss: $a38eaca20b61fcf5$var$stack,
                    children: [
                        logo,
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $lJwTu.ModalTitle), {
                                    children: title
                                }),
                                subtitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    color: subtitleColor,
                                    size: "medium",
                                    children: subtitle
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $59OcG.ModalBody), {
                            children: children
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4gAvD.ModalFooter), {
                            children: actions
                        })
                    ]
                }),
                !!rightContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $a38eaca20b61fcf5$var$sideContainer,
                        $a38eaca20b61fcf5$var$rightSideContainer
                    ],
                    children: rightContent
                })
            ]
        })
    });
};
module.exports["Modal"] = $a38eaca20b61fcf5$export$2b77a92f1a5ad772;

});

parcelRegister("59OcG", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $crya1 = parcelRequire("crya1");


var $804cB = parcelRequire("804cB");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");

const $4494e4f87dd19321$var$container = (0, $ecnYn.xcss)({
    flex: '1 1 auto',
    overflowY: 'auto'
});
const $4494e4f87dd19321$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $crya1.TouchScrollable), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
            space: "space.300",
            xcss: $4494e4f87dd19321$var$container,
            testId: testId,
            children: children
        })
    });
};
module.exports["ModalBody"] = $4494e4f87dd19321$export$cb540d8b0ef7906c;

});

parcelRegister("4gAvD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $804cB = parcelRequire("804cB");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");

const $f0cb77ae0ad3836b$var$wrapStyles = (0, $ecnYn.xcss)({
    flexWrap: 'wrap-reverse'
});
const $f0cb77ae0ad3836b$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $f0cb77ae0ad3836b$var$wrapStyles,
        children: children
    });
};
module.exports["ModalFooter"] = $f0cb77ae0ad3836b$export$519437715052e656;

});

parcelRegister("lJwTu", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $804cB = parcelRequire("804cB");

const $b97fbf5d6df63832$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        testId: testId,
        size: "large",
        id: titleId,
        children: children
    });
};
module.exports["ModalTitle"] = $b97fbf5d6df63832$export$b26fae16ba5468aa;

});


//# sourceMappingURL=base-component.7e744f50.js.map
